<template>
    <div class="flex h-full">
        <div class="px-4 h-full flex items-center text-white" :class="ui.pijlerclass"><NuxtLink :to="ui.to">{{ui.name}}</NuxtLink></div>
        <div class="h-0 w-0 border-solid border-t-transparent border-t-20 border-b-transparent border-b-20 border-r-transparent border-r-0 border-l-15" :class="ui.pijlclass"></div>
    </div>
</template>

<script setup>
    const pathTools = usePathTools();

    const ui = computed(() => {
        if (pathTools.inCursusOpleidingPijler())
            return {
                pijlerclass: 'bg-indigo',
                pijlclass: 'border-l-indigo',
                to: '/cursus-opleiding',
                name: 'cursus | opleiding',
            }

        if (pathTools.inStudiewijzerPijler())
            return {
                pijlerclass: 'bg-teal',
                pijlclass: 'border-l-teal',
                to: '/studiewijzer',
                name: 'studiewijzer',
            }

        if (pathTools.inNt2Pijler())
            return {
                pijlerclass: 'bg-azuur',
                pijlclass: 'border-l-azuur',
                to: '/nt2',
                name: 'NT2 | Dutch',
            }

        return {
            pijlerclass: 'hidden',
            pijlclass: 'hidden',
            to: '/',
            name: ''
        }

    })  

</script>
